import { connect } from 'react-redux';

import { isCancel } from 'axios';
import ParticipantsFieldSet from './ParticipantsFieldSet';

import { usersSearch } from '../../../../../../core/api/search';
import {
  currentUserId as getCurrentUserId,
  currentUser as getCurrentUser,
} from '../../../../../../core/selectors/user';
import { isInstructor } from '../../../../../../core/selectors/classroom';
import { getFullName } from '../../../../../utils/user';
import { getCurrentClassRoom } from '../../../../../../core/utils/data';

const formattedUsersSearch = async ({
  state,
  selectedSet,
  withNoGroupSet,
  sessionToken,
  spaceId,
  query,
}) => {
  try {
    const users = await usersSearch({ sessionToken, spaceId, query });
    return users.reduce((acc, user) => {
      const isEducator = isInstructor(state, user.id);
      const inGroup = selectedSet.has(user.id) || !withNoGroupSet.has(user.id);
      const eligible = isEducator || !inGroup;
      return eligible
        ? [...acc, { label: getFullName(user), isEducator, ...user }]
        : acc;
    }, []);
  } catch (e) {
    if (isCancel(e)) {
      return null;
    }
    return [];
  }
};

const mapStateToProps = (
  state,
  { selected, onSelect, studentsWithNoGroup }
) => {
  const selectedSet = new Set(selected.map(({ id }) => id));
  const withNoGroupSet = new Set(studentsWithNoGroup.map(({ id }) => id));
  const currentUser = getCurrentUser(state);
  const space = getCurrentClassRoom(state);
  const { sessionToken } = state.user.user;

  return {
    isCurrentUserSelected: selectedSet.has(getCurrentUserId(state)),
    onSelectCurrentUser: () =>
      onSelect({ ...currentUser, id: currentUser.objectId }),
    search: (query) =>
      formattedUsersSearch({
        state,
        selectedSet,
        withNoGroupSet,
        sessionToken,
        spaceId: space && space.objectId,
        query,
      }),
  };
};

export default connect(mapStateToProps)(ParticipantsFieldSet);
